import {CUSTOM_ELEMENTS_SCHEMA, NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {RouterModule} from '@angular/router';

import {I18nModule, UrlModule} from '@spartacus/core';

import {CheckoutPaymentsComponent} from '@app/checkout/checkout-payments/checkout-payments.component';
import {DefaultModalModule} from '@app/shared/modal/default-modal.module';
import {CheckoutDetailSectionModule} from '@app/checkout/checkout-detail-section/checkout-detail-section.module';

@NgModule({
  declarations: [
    CheckoutPaymentsComponent,
  ],
  imports: [
    CommonModule,
    I18nModule,
    UrlModule,
    RouterModule,
    DefaultModalModule,
    CheckoutDetailSectionModule,
  ],
  exports: [
    CheckoutPaymentsComponent,
  ],
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA
  ],
})
export class CheckoutPaymentsModule {
}
